// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";

// React Router
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Setup menu items
const setupMenus = [
  {
    title: "Payroll Run",
    description: "Process payroll for the month",
    icon: "schedule",
    route: "/payroll/run",
  },
  {
    title: "Payroll Preview",
    description: "Validate payroll before approval",
    icon: "visibility",
    route: "/payroll/preview",
  },
  {
    title: "Payroll Approval",
    description: "Multi-level authorization for payroll",
    icon: "verified_user",
    route: "/payroll/approval",
  },
  {
    title: "Payroll History",
    description: "View past payroll runs",
    icon: "history",
    route: "/payroll/history",
  },
  {
    title: "Payslip Preview",
    description: "View payslip",
    icon: "description",
    route: "/payroll/payslip",
  },
  {
    title: "Exit Due Review",
    description: "Resolve pending staff exits that block payroll finalization",
    icon: "rule",
    route: "/payroll/exit-due-review",
  },
];

function SetupMenu() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Grid container spacing={3} alignItems="stretch">
          {setupMenus.map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item.route} sx={{ display: "flex" }}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": { transform: "translateY(-5px)", boxShadow: 8 },
                }}
              >
                <CardActionArea
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    p: 2,
                  }}
                  onClick={() => navigate(item.route)}
                >
                  {/* Icon */}
                  <MDBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      bgcolor: "primary.light",
                      color: "primary.main",
                      mx: "auto",
                      boxShadow: 3,
                    }}
                  >
                    <Icon sx={{ fontSize: 30 }}>{item.icon}</Icon>
                  </MDBox>

                  {/* Content */}
                  <CardContent
                    sx={{
                      textAlign: "center",
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default SetupMenu;
